import React, { useState } from 'react';

const NecrovaIndustries = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [newsArticles, setNewsArticles] = useState([
    {
      id: 1,
      title: "We've Done It! Welcome To Our Website",
      date: "March 19, 2025",
      summary: "Pardon Our Dust!",
      content: "Welcome! For the first time we have a Real Site! We cant wait to show you what wehave been working on!",
      imageUrl: "https://cdn.4fingerstudios.com/Necrova/Blog%201.png" // Add image URL here
    },
    // Add more articles with images as needed
  ]);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSelectedArticle(null);
  };

  const handleArticleSelect = (article) => {
    setSelectedArticle(article);
  };

  const handleBackToNews = () => {
    setSelectedArticle(null);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'team':
        return renderTeamPage();
      case 'story':
        return renderStoryPage();
      case 'news':
        return renderNewsPage();
      default:
        return renderHomePage();
    }
  };

  const renderHomePage = () => (
    <>
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-image">
            <div className="logo-large">
         <a href="https://necrova.4fingerstudios.com/OS">
      <img
        src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/Full.png"
        width="450"
        height="450"
        alt="Description of image"
        className="cursor-pointer hover:opacity-80 transition-opacity"
      />
    </a>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <div className="content-container">
          <h1>Pioneering the Future</h1>
          <p>
            At Necrova Industries, we're reshaping the boundaries of possibility through innovative technologies 
            and visionary solutions. Our commitment to excellence drives us to create products that 
            transform industries and enhance lives.
          </p>
          <div className="cta-buttons">
             <a 
    href="#" 
    className="toon-button"
    onClick={() => handleExternalLink('https://necrova.4fingerstudios.com/Toon-Tales-Museum')}
  >
    Toon Tales Museum
  </a>
          </div>
        </div>
      </div>
    </>
  );

  const renderTeamPage = () => (
    <div className="page-container">
      <div className="page-header team-header">
        <h1>Meet the Team</h1>
        <div className="diamond-decoration"></div>
      </div>
       
      <div className="team-grid">
        <div className="team-member">
          <div className="member-image">
            <img src="https://cdn.4fingerstudios.com/Necrova/Lunix.png" alt="Lunix" className="member-photo" />
          </div>
          <h3>Lunix</h3>
          <p className="member-title">Founder</p>
          <p className="member-bio">
            Founding this company in #### was a dream for me and my brother. If he was still here he would be proud of where we ended up.
          </p>
        </div>
        
        {/* Second team member card */}
        <div className="team-member">
          <div className="member-image">
            <img src="https://cdn.4fingerstudios.com/Necrova/Brother.png" alt="Team Member Name" className="member-photo" />
          </div>
          <h3>####</h3>
          <p className="member-title">Co-Founder</p>
          <p className="member-bio">
            M# ### Brother #o##d## ##i# P#### ## C##A## F## ##D T## #U#T##
          </p>
        </div>

          {/* Third team member card */}
        <div className="team-member">
          <div className="member-image">
            <img src="https://cdn.4fingerstudios.com/assets/images/PH.png" alt="Lunix" className="member-photo" />
          </div>
          <h3>James</h3>
          <p className="member-title">Head Scientist</p>
          <p className="member-bio">
            Hi Im James, Im the head scientist here at Necrova. I Worked here when this place was still called W.a.f.f.l.e Labs. My sister Is jane We are twins.
          </p>
        </div>

  {/* Fourth team member card */}
  <div className="team-member">
          <div className="member-image">
            <img src="https://cdn.4fingerstudios.com/assets/images/PH.png" alt="Lunix" className="member-photo" />
          </div>
          <h3>Jane</h3>
          <p className="member-title">Co-Head Scientist</p>
          <p className="member-bio">
            Hi Im Jane, Im the Co-head scientist here at Necrova. My Brother Is james We are twins.
          </p>
        </div>









      </div>
    </div>  

    
);

  

  const renderNewsPage = () => {
    if (selectedArticle) {
      return (
        <div className="page-container">
          <div className="article-container">
            <button className="back-button" onClick={handleBackToNews}>
              ← Back to News
            </button>
            <h1 className="article-title">{selectedArticle.title}</h1>
            <p className="article-date">{selectedArticle.date}</p>
            {selectedArticle.imageUrl && (
              <div className="article-image-container">
                <img 
                  src={selectedArticle.imageUrl} 
                  alt={selectedArticle.title} 
                  className="article-full-image" 
                />
              </div>
            )}
            <div className="article-content">
              <p>{selectedArticle.content}</p>
            </div>
          </div>
        </div>
      );
    }
    
    // Article list view with images
    return (
      <div className="page-container">
        <h1 className="page-title">Latest News</h1>
        <div className="news-grid">
          {newsArticles.map((article) => (
            <div 
              key={article.id} 
              className="news-card" 
              onClick={() => handleArticleSelect(article)}
            >
              {article.imageUrl && (
                <div className="news-card-image-container">
                  <img 
                    src={article.imageUrl} 
                    alt={article.title} 
                    className="news-card-image" 
                  />
                </div>
              )}
              <div className="news-card-content">
                <h2 className="news-card-title">{article.title}</h2>
                <p className="news-card-date">{article.date}</p>
                <p className="news-card-summary">{article.summary}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleExternalLink = (url) => {
    window.location.href = url;
  };
  return (
    <div className="necrova-container">
      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="logo-container">
          <div className="logo" onClick={() => handlePageChange('home')}>
          <img 
          src="https://cdn.4fingerstudios.com/Necrova/NecrovaStuffas/NECROVA.png" 
          width="200" 
          height="200" 
          alt="Description of image"
        />
          </div>
        </div>
        <div className="nav-links">
          <a 
            href="#" 
            className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
            onClick={() => handlePageChange('home')}
          >
            Home
          </a>
          <a 
            href="#" 
            className={`nav-link ${currentPage === 'team' ? 'active' : ''}`}
            onClick={() => handlePageChange('team')}
          >
            Meet the Team
          </a>
          
          <a 
            href="#" 
            className={`nav-link ${currentPage === 'news' ? 'active' : ''}`}
            onClick={() => handlePageChange('news')}
          >
            Company News
          </a>
          <a 
            href="#" 
            className={`nav-link ${currentPage === '#' ? 'active' : ''}`}
            onClick={() => handlePageChange('#')}
          >
            Coming Soon!
          </a>
          </div>
          
        <div className="login-container">
          <a href="https://necrova.4fingerstudios.com/Login" className="login-button">Login</a>
        </div>
      </nav>

      {/* Page Content */}
      {renderPage()}

      {/* CSS Styles */}
      <style jsx>{`
      /* Add this to your style jsx section */
.toon-button {
  margin: 0 1rem;
  padding: 0.6rem 1.2rem;
  background: linear-gradient(90deg, #FF9E00, #FF3D00);
  border: 3px solid #fff;
  border-radius: 25px;
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
  position: relative;
  box-shadow: 0 4px 0 #D32F2F;
  transition: all 0.2s;
  animation: bounce 2s infinite;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.5);
}

.toon-button:hover {
  transform: scale(1.05);
  background: linear-gradient(90deg, #FFB347, #FF5722);
  box-shadow: 0 6px 0 #D32F2F;
}

.toon-button:active {
  transform: translateY(4px);
  box-shadow: 0 0 0 #D32F2F;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
        /* Global styles */
        .necrova-container {
          font-family: 'Arial', sans-serif;
          margin: 0;
          padding: 0;
          color: white;
          background: linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 50%, #16213e 100%);
          min-height: 100vh;
        }

        /* Navigation styles */
        .navbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 2rem;
          height: 70px;
          background-color: rgba(15, 15, 26, 0.95);
          border-bottom: 1px solid rgba(138, 43, 226, 0.3);
        }

        .logo-container {
          flex: 1;
        }

        .logo {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        .company-name {
          margin-left: 10px;
          font-size: 1.5rem;
          font-weight: bold;
          letter-spacing: 2px;
        }

        .nav-links {
          flex: 2;
          display: flex;
          justify-content: center;
        }

        .nav-link {
          margin: 0 1rem;
          padding: 0.5rem 1rem;
          color: white;
          text-decoration: none;
          font-size: 1rem;
          position: relative;
        }

        .nav-link.active::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 0;
          width: 100%;
          height: 3px;
          background-color: #e94560;
        }

        .nav-link:hover {
          color: #8a2be2;
        }

        .login-container {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }

        .login-button {
          padding: 0.5rem 1.5rem;
          background: transparent;
          border: 1px solid #8a2be2;
          color: white;
          border-radius: 4px;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .login-button:hover {
          background-color: #8a2be2;
        }

        /* Hero section */
        .hero-section {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 80vh;
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #8a2be2 0%, transparent 50%);
          clip-path: polygon(0 0, 30% 0, 0 100%);
          z-index: 1;
        }

        .hero-content {
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
        }

        /* Content section */
        .content-section {
          padding: 2rem;
          text-align: center;
        }

        .content-container {
          max-width: 800px;
          margin: 0 auto;
        }

        .content-container h1 {
          font-size: 2.5rem;
          margin-bottom: 1.5rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .content-container p {
          font-size: 1.2rem;
          line-height: 1.6;
          margin-bottom: 2rem;
        }

        .cta-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
        }

        .primary-button {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          border: none;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .primary-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(138, 43, 226, 0.5);
        }

        .secondary-button {
          padding: 0.75rem 1.5rem;
          background: transparent;
          border: 1px solid #8a2be2;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .secondary-button:hover {
          background-color: rgba(138, 43, 226, 0.2);
        }

        /* Page Container */
        .page-container {
          padding: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .page-header {
          text-align: center;
          margin-bottom: 3rem;
          position: relative;
          padding-bottom: 1rem;
        }

        .page-header h1 {
          font-size: 3rem;
          margin-bottom: 1rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .diamond-decoration {
          position: absolute;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #8a2be2, #e94560);
          z-index: 1;
        }

        /* Team Page */
        .team-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 2rem;
        }

        .team-member {
          background-color: rgba(26, 26, 46, 0.7);
          border-radius: 8px;
          padding: 1.5rem;
          text-align: center;
          transition: all 0.3s ease;
          border: 1px solid rgba(138, 43, 226, 0.3);
        }

        .team-member:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(138, 43, 226, 0.2);
        }

        .member-image {
          width: 120px;
          height: 120px;
          margin: 0 auto 1rem;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid #8a2be2;
        }

        .image-placeholder {
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #8a2be2, #e94560);
        }

        .member-title {
          color: #8a2be2;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .member-bio {
          font-size: 0.9rem;
          line-height: 1.5;
        }

        /* Story Page */
        .story-content {
          max-width: 800px;
          margin: 0 auto;
        }

        .story-section {
          margin-bottom: 3rem;
        }

        .story-section h2 {
          font-size: 1.8rem;
          margin-bottom: 1rem;
          color: #8a2be2;
        }

        .story-section p {
          font-size: 1.1rem;
          line-height: 1.8;
        }

        /* News Page */
      /* Add these styles to your CSS file */

/* News list view image styles */
.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.news-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.news-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.news-card-image-container {
  height: 180px;
  overflow: hidden;
}

.news-card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-card-content {
  padding: 15px;
}

/* Full article view image styles */
.article-image-container {
  margin: 20px 0;
  max-height: 400px;
  overflow: hidden;
  border-radius: 8px;
}

.article-full-image {
  width: 100%;
  object-fit: cover;
}

        .news-content {
          padding: 1.5rem;
        }

        .news-date {
          color: #8a2be2;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }

        .news-summary {
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 1.5rem;
        }

        .read-more-button {
          padding: 0.5rem 1rem;
          background: transparent;
          border: 1px solid #8a2be2;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.9rem;
          transition: all 0.3s ease;
        }

        .read-more-button:hover {
          background-color: rgba(138, 43, 226, 0.2);
        }

        .admin-section {
          text-align: center;
          margin-top: 2rem;
        }

        .admin-button {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(90deg, #8a2be2, #e94560);
          border: none;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .admin-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(138, 43, 226, 0.5);
        }

        /* Article Page */
        .article-container {
          max-width: 800px;
          margin: 0 auto;
          background-color: rgba(26, 26, 46, 0.7);
          border-radius: 8px;
          padding: 2rem;
          border: 1px solid rgba(138, 43, 226, 0.3);
        }

        .back-button {
          padding: 0.5rem 1rem;
          background: transparent;
          border: 1px solid #8a2be2;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 0.9rem;
          margin-bottom: 2rem;
          transition: all 0.3s ease;
        }

        .back-button:hover {
          background-color: rgba(138, 43, 226, 0.2);
        }

        .article-title {
          font-size: 2rem;
          margin-bottom: 1rem;
          color: #e94560;
        }

        .article-date {
          color: #8a2be2;
          font-size: 1rem;
          margin-bottom: 2rem;
        }

        .article-content {
          font-size: 1.1rem;
          line-height: 1.8;
        }
      `}</style>
    </div>
  );
};

export default NecrovaIndustries;